import React from 'react';
import LayoutPlantDropdown from './LayoutPlantDropdown';

const LayoutDashboardHeader = ({ setCurrentPage, plantas, onSelectPlant }) => {
  return (
    <header className="bg-white shadow-sm p-4 flex flex-col sm:flex-row justify-between items-center rounded-b-2xl transition-colors duration-300">
      <h1 className="text-2xl font-bold text-gray-900 mb-2 sm:mb-0">Control de Plantas</h1>
      <nav className="flex flex-wrap justify-center gap-2 sm:space-x-3 sm:flex-nowrap items-center">
        <button
          onClick={() => setCurrentPage('dashboard')}
          className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors font-medium text-base sm:text-lg"
        >
          Dashboard
        </button>
        <LayoutPlantDropdown
          plantas={plantas}
          setCurrentPage={setCurrentPage}
          onSelectPlant={onSelectPlant}
        />
        <button
          onClick={() => setCurrentPage('operarioHistory')}
          className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors font-medium text-base sm:text-lg"
        >
          Historial de Operarios
        </button>
        <button
          onClick={() => setCurrentPage('statistics')}
          className="px-4 py-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors font-medium text-base sm:text-lg"
        >
          Estadísticas
        </button>
      </nav>
    </header>
  );
};

export default LayoutDashboardHeader;